"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldStorage = exports.FunctionStroageReference = void 0;
const React = __importStar(require("react"));
const type_1 = require("../../../type");
const FunctionStroageReference = ({ props }) => {
    const isNumber = typeof props.FunctionGetThisValue === type_1.TYPE_NUMBER;
    // console.log("FunctionStroageReference", props);
    try {
        if (props.parentIndex >= 0 &&
            props.parentKey &&
            props.fieldIndex >= 0 &&
            props.name &&
            props.grandParentIndex >= 0 &&
            props.grandParentKey &&
            props.parentKey !== props.grandParentKey) {
            // console.log("IN 1", props);
            props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex][props.parentKey][props.fieldIndex] = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex][props.parentKey][props.fieldIndex]), { [props.name]: props.FunctionGetThisValue });
        }
        else if (props.parentIndex >= 0 &&
            props.parentKey &&
            props.fieldIndex >= 0 &&
            props.name &&
            props.parentKey === props.grandParentKey) {
            // console.log("IN 2", props);
            props.FieldReference.current[props.parentIndex][props.parentKey][props.fieldIndex] = Object.assign(Object.assign({}, props.FieldReference.current[props.parentIndex][props.parentKey][props.fieldIndex]), { [props.name]: props.FunctionGetThisValue });
        }
        else if (props.parentKey &&
            props.name &&
            props.grandParentIndex >= 0 &&
            props.grandParentKey &&
            props.parentKey !== props.grandParentKey) {
            if (props.childType === type_1.TYPE_OBJECT) {
                if (props.parentIndex >= 0) {
                    // this is the case where the parent is an array
                    // console.log("IN 3.1", props);
                    props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex][props.parentKey] = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex][props.parentKey]), { [props.name]: props.FunctionGetThisValue });
                }
                else {
                    // this is the case where the parent is an object
                    // console.log("IN 3.2", props);
                    props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentKey] = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentKey]), { [props.name]: props.FunctionGetThisValue });
                }
            }
            else if (props.childType === type_1.TYPE_ARRAY) {
                if (props.fieldIndex >= 0) {
                    // console.log("IN 3.3.1", props);
                    props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentKey][props.fieldIndex] = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentKey][props.fieldIndex]), { [props.name]: props.FunctionGetThisValue });
                }
                else {
                    // console.log("IN 3.3.2", props);
                    props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentKey] = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentKey]), { [props.name]: props.FunctionGetThisValue });
                }
            }
        }
        else if (props.childType === type_1.TYPE_OBJECT &&
            props.parentIndex >= 0 &&
            props.parentKey &&
            props.name &&
            props.parentKey === props.grandParentKey) {
            // console.log("IN 4", props);
            props.FieldReference.current[props.parentIndex][props.parentKey] = Object.assign(Object.assign({}, props.FieldReference.current[props.parentIndex][props.parentKey]), { [props.name]: props.FunctionGetThisValue });
        }
        else if (props.name) {
            // console.log("IN 5", props);
            if (isNumber && props.FunctionGetThisValue >= 0) {
                props.FieldReference.current[props.index] = props.FunctionGetThisValue;
            }
            else {
                props.FieldReference.current[props.index] = props.FunctionGetThisValue;
            }
        }
        else {
            // console.log("IN 6", props);
            return;
        }
    }
    catch (error) {
        console.error("ERROR IN FUNCTION ", error);
    }
};
exports.FunctionStroageReference = FunctionStroageReference;
const FieldStorage = (props) => {
    return (React.createElement("div", { ref: () => {
            (0, exports.FunctionStroageReference)({
                props,
            });
        } }));
};
exports.FieldStorage = FieldStorage;
